import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

interface SucceedProps {
}

const Container = styled.div`
    padding: 24px;
    text-align: center;
    max-width: 400px;
    margin: 0 auto;
`;

const Icon = styled(CheckCircleFilled)`
    font-size: 64px;
    color: #52c41a;
    margin-bottom: 24px;
`;

const Title = styled.h2`
    font-size: 24px;
    margin-bottom: 16px;
`;

const Description = styled.p`
    color: #666;
    margin-bottom: 32px;
`;

const ButtonGroup = styled.div`
    display: flex;
    justify-content: center;
    gap: 16px;
`;

const Succeed: React.FC<SucceedProps> = ({ }) => {
    return (
        <Container>
            <Icon />
            <Title>提交成功</Title>
            <Description>
                您的问诊信息已提交成功，我们会尽快为您安排医生进行回复
            </Description>
        </Container>
    );
};

export default Succeed; 